var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as HLS from 'hls.js';
import * as React from 'react';
import PlaybackManager from './PlaybackManager';
import { PlayerState } from './types';
import 'rc-slider/assets/index.css';
import { ARROWS_UP_SVG, ARROWS_DOWN_SVG, ARROWS_LEFT_SVG, ARROWS_RIGHT_SVG, PLAY_SMALL_WHITE_SVG, PAUSE_SMALL_WHITE_SVG, CHECKMARK_SVG, PLUS_SVG, DOWNLOAD_SVG, SETTINGS_SVG, QUEUE_SVG, VOLUME_0_SVG, VOLUME_2_SVG, VOLUME_1_SVG, MINUS_SVG, CLOSE_SVG } from '../assets';
import Button from '../components/Button';
import * as moment from 'moment';
import Slider from 'rc-slider';
import Queue from './Queue';
import { PlayerContextConsumer } from '../context/player';
import ToggleInput from '../components/ToggleInput';
import Loader from '../components/Loader';
import { CrateContextConsumer } from "../context/crate";
import * as ReactTooltip from 'react-tooltip';
import { messages } from '../messages';
import { ListView } from '../components';
import { displayDate } from '../util/date';
var Player = /** @class */ (function (_super) {
    __extends(Player, _super);
    function Player(props) {
        var _this = _super.call(this, props) || this;
        _this.togglePipOnNextTimeUpdate = false;
        _this.didBufferAlready = false;
        _this.state = {
            paused: PlaybackManager.getInstance().getPlayingState() == PlayerState.Paused,
            hq: PlaybackManager.getInstance().hq,
            muted: false,
            repeat: PlaybackManager.getInstance().autorepeat,
            loading: false,
            visible: false,
            versionPopupOpen: false,
            volumePopupOpenDelayedClose: false,
            queuePopupOpen: false,
            queuePopupOpenDelayedClose: false,
            hqPopupOpen: false,
            hideVideoModal: false,
            shadowVideoClose: false,
            volume: 0,
            popupVisibleState: 'hidden',
            pip: true
        };
        PlaybackManager.getInstance()._internalPlayer = _this;
        _this.bindVideoElem = _this.bindVideoElem.bind(_this);
        _this.handleAudioEvent = _this.handleAudioEvent.bind(_this);
        return _this;
    }
    Player.hlsSupported = function () {
        return HLS.isSupported();
    };
    Player.prototype.componentDidMount = function () {
        var _this = this;
        document.addEventListener('click', function (e) {
            function hasSomeParentTheClass(element, classname) {
                if (!element) {
                    return true; // element is not in dom anymore
                }
                if (!element.tagName) {
                    if (element.parentNode) {
                        return hasSomeParentTheClass(element.parentNode, classname);
                    }
                    else {
                        return true;
                    }
                }
                if (element.tagName.toLowerCase() == 'body') {
                    return false;
                }
                if (!element.classList)
                    return hasSomeParentTheClass(element.parentNode, classname);
                if (element.className.split(' ').indexOf(classname) >= 0)
                    return true;
                return hasSomeParentTheClass(element.parentNode, classname);
            }
            if (hasSomeParentTheClass((e.target || e.currentTarget), 'popup-click-handler')) {
                return;
            }
            if (_this.queuePopup && !_this.queuePopup.contains(e.target)) {
                _this.closeQueuePopup();
            }
            if (_this.hqPopup && !_this.hqPopup.contains(e.target)) {
                _this.setState({ hqPopupOpen: false });
            }
            if (_this.versionPopup && !_this.versionPopup.contains(e.target)) {
                _this.setState({ versionPopupOpen: false });
            }
        });
    };
    Player.prototype.initHLSIfRequired = function () {
        var _this = this;
        if (Player.hlsSupported()) {
            if (this.hls_player) {
                this.hls_player.destroy();
                this.hls_player = undefined;
            }
            this.hls_player = new HLS({
                initialLiveManifestSize: 1,
                xhrSetup: function (xhr, url) {
                    xhr.withCredentials = true;
                }
            });
            this.hls_player.on(HLS.Events.ERROR, function (event, data) {
                if (data.fatal) {
                    switch (data.type) {
                        case HLS.ErrorTypes.NETWORK_ERROR:
                            if (data.details == 'manifestLoadError') {
                                if (data.networkDetails) {
                                    if (data.networkDetails.status != 200) {
                                        _this.onError && _this.onError('FileNotFound', data);
                                        return;
                                    }
                                }
                            }
                            _this.onError && _this.onError('Unknown', data);
                            break;
                        case HLS.ErrorTypes.MEDIA_ERROR:
                            _this.hls_player.recoverMediaError();
                            break;
                        default:
                            break;
                    }
                }
            });
        }
    };
    Player.prototype.isSafari = function () {
        return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    };
    Player.prototype.play = function (_a) {
        var _this = this;
        var url = _a.url, onEnd = _a.onEnd, onError = _a.onError, onPlay = _a.onPlay, onProgress = _a.onProgress, onStateChange = _a.onStateChange, totalDuration = _a.totalDuration, isPreview = _a.isPreview;
        if (!this.state.visible) {
            this.setState({ visible: true, pip: true });
            setTimeout(function () {
                _this.setState({ popupVisibleState: 'visible' });
            }, 300);
        }
        this.setState({ pip: true });
        this.onError = onError;
        this.onPlay = onPlay;
        this.onProgress = onProgress;
        this.onStateChange = onStateChange;
        this.onEnd = onEnd;
        this.totalDuration = totalDuration;
        this.isPreview = isPreview;
        this.initHLSIfRequired();
        if (this.hls_player && url.endsWith('m3u8') && !this.isSafari()) {
            if (!PlaybackManager.getInstance().isPlayingVideo()) {
                this.togglePiP(false);
            }
            this.videoElem && this.hls_player.attachMedia(this.videoElem);
            this.hls_player.on(HLS.Events.MEDIA_ATTACHED, function () {
                _this.hls_player.loadSource(url);
                _this.videoElem && _this.videoElem.play();
            });
        }
        else if (this.videoElem) {
            if (this.videoElem.src != url) {
                if (!PlaybackManager.getInstance().isPlayingVideo()) {
                    this.togglePiP(false);
                }
                this.videoElem.src = url;
                this.didBufferAlready = false;
            }
            this.videoElem.play();
        }
    };
    Player.prototype.pause = function (cb) {
        this.videoElem && this.videoElem.pause();
        this.onStateChange && this.onStateChange(PlayerState.Paused);
        cb && cb();
    };
    Player.prototype.seek = function (to) {
        if (this.videoElem)
            this.videoElem.currentTime = to;
    };
    Player.prototype.stop = function () {
        this.videoElem && this.videoElem.pause();
    };
    Player.prototype.handleAudioEvent = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (event.type) {
                    case 'play':
                        this.onStateChange && this.onStateChange(PlayerState.Buffering);
                        // No play event, we do not have the duration yet
                        break;
                    case 'playing':
                        this.onStateChange && this.onStateChange(PlayerState.Playing);
                        if (this.didBufferAlready) {
                            this.togglePipOnNextTimeUpdate = true;
                        }
                        break;
                    case 'pause':
                        this.onStateChange && this.onStateChange(PlayerState.Paused);
                        break;
                    case 'durationchange':
                        break;
                    case 'timeupdate':
                        if (this.togglePipOnNextTimeUpdate) {
                            this.togglePipOnNextTimeUpdate = false;
                            this.togglePiP(true);
                        }
                        this.onProgress && this.videoElem && this.onProgress(this.videoElem.currentTime, this.videoElem.duration);
                        break;
                    case 'loadedmetadata':
                        this.onStateChange && this.onStateChange(PlayerState.Playing);
                        this.onPlay && this.videoElem && this.onPlay(this.videoElem.duration);
                        this.videoElem && this.setState({ currentDuration: this.videoElem.duration });
                        break;
                    case 'ended':
                        if (this.isPreview && this.playPauseButton) {
                            this.props.onPreviewtrackEnded(this.playPauseButton);
                        }
                        this.onEnd && this.onEnd(this.playPauseButton);
                        break;
                    case 'error':
                        this.onError && this.onError('FileNotFound', undefined);
                        break;
                    case 'canplaythrough':
                        this.togglePipOnNextTimeUpdate = true;
                        this.didBufferAlready = true;
                        break;
                }
                return [2 /*return*/];
            });
        });
    };
    Player.prototype.bindVideoElem = function (elem) {
        this.videoElem = elem;
        if (!elem) {
            return;
        }
        this.videoElem.disablepictureinpicture = !this.props.usePip ? 'false' : 'trtue';
        this.hls_player && this.hls_player.attachMedia(this.videoElem);
        this.videoElem.addEventListener('seeking', this.handleAudioEvent);
        this.videoElem.addEventListener('timeupdate', this.handleAudioEvent);
        this.videoElem.addEventListener('seeked', this.handleAudioEvent);
        this.videoElem.addEventListener('pause', this.handleAudioEvent);
        this.videoElem.addEventListener('canplay', this.handleAudioEvent);
        this.videoElem.addEventListener('canplaythrough', this.handleAudioEvent);
        this.videoElem.addEventListener('ended', this.handleAudioEvent);
        this.videoElem.addEventListener('playing', this.handleAudioEvent);
        this.videoElem.addEventListener('error', this.handleAudioEvent);
        this.videoElem.addEventListener('loadedmetadata', this.handleAudioEvent);
        this.videoElem.addEventListener('loadeddata', this.handleAudioEvent);
        this.videoElem.addEventListener('durationchange', this.handleAudioEvent);
        this.videoElem.addEventListener('play', this.handleAudioEvent);
        this.videoElem.addEventListener('webkitfullscreenchange', this.onVideoFullScreen.bind(this));
        this.videoElem.addEventListener('mozfullscreenchange', this.onVideoFullScreen.bind(this));
        this.videoElem.addEventListener('fullscreenchange', this.onVideoFullScreen.bind(this));
        this.videoElem.addEventListener('enterpictureinpicture', this.onPiP.bind(this));
        this.videoElem.addEventListener('leavepictureinpicture', this.onPiP.bind(this));
        this.videoElem.addEventListener('webkitpresentationmodechanged', this.onPiP.bind(this));
        this.setState({ volume: this.videoElem.volume });
    };
    Player.prototype.pipOpen = function () {
        if (this.videoElem.webkitSupportsPresentationMode)
            return this.videoElem.webkitPresentationMode != 'inline';
        if (document.pictureInPictureEnabled)
            return document.pictureInPictureElement;
        return false;
    };
    Player.prototype.usePip = function () {
        if (!this.props.usePip) {
            return false;
        }
        if (!PlaybackManager.getInstance().isPlayingVideo()) {
            return false;
        }
        if (!this.state.pip) {
            return false;
        }
        if (this.videoElem) {
            if (this.videoElem.webkitSupportsPresentationMode)
                return typeof this.videoElem.webkitSupportsPresentationMode == 'function';
            if (document.pictureInPictureEnabled && this.videoElem.requestPictureInPicture && document.exitPictureInPicture)
                return true;
        }
        return false;
    };
    Player.prototype.onPiP = function (e) {
        if (!this.pipOpen() && this.videoElem && !this.videoElem.paused) {
            debugger;
            this.setState({ pip: false, hideVideoModal: false });
        }
        else
            this.setState({ hideVideoModal: this.pipOpen(), pip: true });
    };
    Player.prototype.onVideoFullScreen = function () {
        var doc = document;
        var state = doc.fullScreen || doc.mozFullScreen || doc.webkitIsFullScreen;
        this.setState({ hideVideoModal: state });
    };
    Player.prototype.togglePiP = function (show) {
        return false;
    };
    Player.prototype.closeQueuePopup = function () {
        var _this = this;
        this.setState({ queuePopupOpen: false });
        setTimeout(function () {
            if (_this.state.queuePopupOpen == false) {
                _this.setState({ queuePopupOpenDelayedClose: false });
            }
        }, 400);
    };
    Player.prototype.setVersionPopupPosition = function (e) {
        if (this.state.versionPopupOpen || !this.audioPlayerContaienr) {
            this.setState({ versionPopupOpen: false });
        }
        else {
            var left = e.currentTarget.getBoundingClientRect().left;
            left += (e.currentTarget.clientWidth / 2);
            left -= 200;
            if (left + 400 > document.body.clientWidth) {
                left = document.body.clientWidth - 400;
            }
            this.setState({ versionPopupPosition: { left: left, bottom: this.audioPlayerContaienr.clientHeight }, versionPopupOpen: true });
        }
    };
    Player.prototype.getVersionPopupStyle = function () {
        if (this.state.versionPopupPosition) {
            return Object.assign({}, this.state.versionPopupPosition, this.state.versionPopupOpen ? { transform: 'translate(0, 0)' } : {}, { visibility: this.state.popupVisibleState });
        }
        return {};
    };
    Player.prototype.setHQPopupPosition = function (e, show) {
        if (this.state.hqPopupOpen || !this.audioPlayerContaienr || !show) {
            this.setState({ hqPopupOpen: false });
        }
        else {
            var left = e.currentTarget.getBoundingClientRect().left;
            left += (e.currentTarget.clientWidth / 2);
            left -= 200;
            if (left + 400 > document.body.clientWidth) {
                left = document.body.clientWidth - 400;
            }
            this.setState({ hqPopupPosition: { left: left, bottom: this.audioPlayerContaienr.clientHeight }, hqPopupOpen: true });
            this.closeQueuePopup();
        }
    };
    Player.prototype.getHQPopupStyle = function () {
        if (this.state.hqPopupPosition) {
            return Object.assign({}, this.state.hqPopupPosition, this.state.hqPopupOpen ? { transform: 'translate(0, 0)' } : {}, { visibility: this.state.popupVisibleState });
        }
        return {};
    };
    Player.prototype.render = function () {
        var _this = this;
        return React.createElement(PlayerContextConsumer, null, function (playbackState) {
            var showVideoModal = PlaybackManager.getInstance().isPlayingVideo() &&
                (playbackState.state == PlayerState.Playing || playbackState.state == PlayerState.Paused || playbackState.state == PlayerState.Buffering)
                && !_this.state.hideVideoModal && !_this.state.shadowVideoClose && !_this.usePip();
            var video = React.createElement("video", { ref: _this.bindVideoElem, disablepictureinpicture: _this.props.usePip ? 'false' : 'true', style: { display: 'block' }, onContextMenu: function (e) {
                    e.preventDefault();
                    return false;
                }, controlsList: "nodownload", className: ((showVideoModal) ? 'video' : ''), width: 0, height: 0, playsInline: true, controls: PlaybackManager.getInstance().isPlayingVideo(), muted: false, onVolumeChange: function (e) {
                    if (_this.state.volume != e.currentTarget.volume) {
                        _this.setState({ volume: e.currentTarget.volume });
                    }
                    else if (e.currentTarget.muted != _this.state.muted) {
                        _this.setState({ muted: e.currentTarget.muted });
                    }
                }, onPlay: function (e) {
                    _this.setState({ shadowVideoClose: false });
                } });
            var track = playbackState.track;
            var tagPosition = track ? track.album.media.findIndex(function (t) { return t.id == track.track.id; }) : -1;
            {
                return React.createElement(React.Fragment, null,
                    video,
                    showVideoModal && React.createElement("div", { className: "video-shadow", onClick: function () {
                            _this.setState({ shadowVideoClose: true }, function () { return PlaybackManager.getInstance().pause(); });
                        } }),
                    React.createElement("div", { ref: function (ref) { return _this.hqPopup = ref; }, className: "hq-popup popup-click-handler", style: _this.getHQPopupStyle() },
                        React.createElement("div", { onClick: function (e) { return _this.setState({ hqPopupOpen: false }); }, className: "close", style: { marginBottom: '10px' } },
                            React.createElement("img", { style: { float: 'right' }, src: CLOSE_SVG, width: 12 })),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "hq-text" }, messages.HQStreaming),
                            React.createElement("div", { className: "theme-black hq-toggle" },
                                React.createElement(ToggleInput, { checked: _this.state.hq, onChange: function (e) {
                                        _this.setState({ hq: e.target.checked });
                                        if (e.target.checked) {
                                            Player.checkHQMiddleware().then(function () {
                                                PlaybackManager.getInstance().hq = true;
                                            }).catch(function (err) {
                                                PlaybackManager.getInstance().hq = false;
                                                _this.setState({ hq: false });
                                            });
                                        }
                                        else {
                                            PlaybackManager.getInstance().hq = e.target.checked;
                                        }
                                    } })))),
                    React.createElement("div", { ref: function (ref) { return _this.versionPopup = ref; }, className: "version-dropdown-content popup-click-handler", style: _this.getVersionPopupStyle() },
                        React.createElement("div", null,
                            React.createElement("div", { onClick: function (e) { return _this.setState({ versionPopupOpen: false }); }, className: "close", style: { marginBottom: '10px' } },
                                React.createElement("img", { style: { float: 'right' }, src: CLOSE_SVG, width: 12 }))),
                        track && track.album.media.map(function (media) {
                            var playing = track.track.id == media.id && playbackState.state == PlayerState.Playing;
                            return React.createElement("div", { key: media.id, className: "version" },
                                React.createElement("div", { className: "col controls" },
                                    React.createElement("div", { className: "my-auto " + ((playing) ? 'pause' : 'play'), onClick: function () {
                                            if (playing) {
                                                PlaybackManager.getInstance().pause();
                                            }
                                            else {
                                                PlaybackManager.getInstance().startTrack({
                                                    album: track.album,
                                                    playlist: track.playlist,
                                                    track: media,
                                                    playbackInfo: media.stream_info
                                                });
                                            }
                                        } },
                                        playing && React.createElement("img", { src: PAUSE_SMALL_WHITE_SVG, className: "pause" }),
                                        !playing && React.createElement("img", { src: PLAY_SMALL_WHITE_SVG, className: "play" }))),
                                React.createElement("div", { className: "col tag" },
                                    React.createElement("div", { className: "my-auto" }, media.tag ? media.tag.name : 'Unknown')),
                                React.createElement("div", { className: "col downloaded-count" },
                                    React.createElement("div", { className: "my-auto" },
                                        React.createElement("div", { className: "my-auto " + (media.download_count > 0 ? 'downloaded' : ''), onClick: function (e) {
                                                e.stopPropagation();
                                                if (_this.props.onMediaDownlod) {
                                                    _this.setState({ downloading: media.id });
                                                    _this.props.onMediaDownlod(media, false, { target: e.currentTarget, desiredPosition: 'up' }).then(function (downloaded) {
                                                        if (downloaded) {
                                                            media.download_count += 1;
                                                            _this.forceUpdate();
                                                        }
                                                    }).finally(function () {
                                                        _this.setState({ downloading: undefined });
                                                    });
                                                }
                                            } }, media.download_count > 0 && React.createElement("img", { src: CHECKMARK_SVG })),
                                        React.createElement("div", { className: "my-auto " + (media.download_count > 1 ? 'downloaded' : ''), onClick: function (e) {
                                                e.stopPropagation();
                                                if (_this.props.onMediaDownlod) {
                                                    _this.setState({ downloading: media.id });
                                                    _this.props.onMediaDownlod(media, false, { target: e.currentTarget, desiredPosition: 'up' }).then(function (downloaded) {
                                                        if (downloaded) {
                                                            media.download_count += 1;
                                                            _this.forceUpdate();
                                                        }
                                                    }).finally(function () {
                                                        _this.setState({ downloading: undefined });
                                                    });
                                                }
                                            } }, media.download_count > 1 && React.createElement("img", { src: CHECKMARK_SVG })),
                                        React.createElement("div", { className: "my-auto " + (media.download_count > 2 ? 'downloaded' : ''), onClick: function (e) {
                                                e.stopPropagation();
                                                if (_this.props.onMediaDownlod) {
                                                    _this.setState({ downloading: media.id });
                                                    _this.props.onMediaDownlod(media, false, { target: e.currentTarget, desiredPosition: 'up' }).then(function (downloaded) {
                                                        if (downloaded) {
                                                            media.download_count += 1;
                                                            _this.forceUpdate();
                                                        }
                                                    }).finally(function () {
                                                        _this.setState({ downloading: undefined });
                                                    });
                                                }
                                            } }, media.download_count > 2 && React.createElement("img", { src: CHECKMARK_SVG })))),
                                React.createElement("div", { className: "col download my-auto" },
                                    React.createElement("div", { className: "my-auto", onClick: function (e) {
                                            e.stopPropagation();
                                            if (_this.props.onMediaDownlod) {
                                                _this.setState({ downloading: media.id });
                                                _this.props.onMediaDownlod(media, false, { target: e.currentTarget, desiredPosition: 'up' }).then(function (downloaded) {
                                                    if (downloaded) {
                                                        media.download_count += 1;
                                                        _this.forceUpdate();
                                                    }
                                                }).finally(function () {
                                                    _this.setState({ downloading: undefined });
                                                });
                                            }
                                        } },
                                        _this.state.downloading && _this.state.downloading == media.id && React.createElement(Loader, { size: 21, style: { margin: 'auto' } }),
                                        !Boolean(_this.state.downloading && _this.state.downloading == media.id) && React.createElement("img", { src: DOWNLOAD_SVG, width: 21 }))),
                                React.createElement("div", { className: "col add-to-crate my-auto" },
                                    React.createElement(CrateContextConsumer, null, function (crate) {
                                        return React.createElement("div", { className: "my-auto", onClick: function (e) {
                                                e.preventDefault();
                                                if (crate.find(function (item) { return item.media[0].id == media.id; }) == undefined) {
                                                    if (_this.props.onAddToCrate) {
                                                        _this.setState({ addingToCrate: media.id });
                                                        _this.props.onAddToCrate(media, { target: e.currentTarget, desiredPosition: 'up' }).finally(function () {
                                                            _this.setState({ addingToCrate: undefined });
                                                        });
                                                    }
                                                }
                                                else {
                                                    if (_this.props.onRemoveFromCrate) {
                                                        _this.setState({ addingToCrate: media.id });
                                                        _this.props.onRemoveFromCrate(media).finally(function () {
                                                            _this.setState({ addingToCrate: undefined });
                                                        });
                                                    }
                                                }
                                            } },
                                            _this.state.addingToCrate && _this.state.addingToCrate == media.id && React.createElement(Loader, { size: 15, style: { margin: 'auto' } }),
                                            !Boolean(_this.state.addingToCrate && _this.state.addingToCrate == media.id) && crate.find(function (item) { return item.media[0].id == media.id; }) == undefined && React.createElement("img", { src: PLUS_SVG, width: 14 }),
                                            !Boolean(_this.state.addingToCrate && _this.state.addingToCrate == media.id) && crate.find(function (item) { return item.media[0].id == media.id; }) != undefined && React.createElement("img", { src: MINUS_SVG, width: 14 }));
                                    })));
                        })),
                    React.createElement(Queue, { innerRef: function (ref) { return _this.queuePopup = ref; }, className: "queue-popup popup-click-handler " + (_this.state.queuePopupOpen ? 'show' : ''), onClose: function () {
                            _this.closeQueuePopup();
                        }, style: { visibility: _this.state.queuePopupOpenDelayedClose ? _this.state.popupVisibleState : 'hidden' } }),
                    React.createElement("div", { ref: function (ref) { return _this.audioPlayerContaienr = ref; }, className: "audio-player " + (!_this.state.visible ? 'hidden' : '') },
                        React.createElement("div", { className: "col album-artwork" },
                            React.createElement("img", { src: track === null || track === void 0 ? void 0 : track.album.cover, className: "artwork" })),
                        React.createElement("div", { className: "col artist-title" }, track && React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "title", "data-tip": true, "data-for": 'track-info' }, track.track.name),
                            React.createElement("div", { className: "artist" }, ListView.renderArtistLink(track.album, _this.props.onArtistClick)))),
                        track && React.createElement(ReactTooltip, { id: 'track-info', "aria-haspopup": 'true', effect: 'solid', event: 'click', globalEventOff: 'click' },
                            React.createElement("ul", null,
                                React.createElement("li", null,
                                    React.createElement("span", { className: "track-info-title" }, messages.Artists),
                                    React.createElement("span", { className: "track-info-text track-info-artist" }, track.album.artist)),
                                React.createElement("li", null,
                                    React.createElement("span", { className: "track-info-title" }, messages.Category),
                                    React.createElement("span", { className: "track-info-text track-info-category" }, track.album.category.name)),
                                React.createElement("li", null,
                                    React.createElement("span", { className: "track-info-title" }, messages.Genre),
                                    React.createElement("span", { className: "track-info-text track-info-genre" }, track.album.genre.name)),
                                React.createElement("li", null,
                                    React.createElement("span", { className: "track-info-title" }, messages.Uploaded),
                                    React.createElement("span", { className: "track-info-text track-info-release" }, displayDate(track.album.created_at))),
                                React.createElement("li", null,
                                    React.createElement("span", { className: "track-info-title" }, messages.BPM),
                                    React.createElement("span", { className: "track-info-text track-info-bpm" }, track.album.bpm)),
                                React.createElement("li", null,
                                    React.createElement("span", { className: "track-info-title" }, messages.Length),
                                    React.createElement("span", { className: "track-info-text track-info-length jp-duration" }, PlayerProgress.formatProgress(_this.state.currentDuration) || '00:00')))),
                        React.createElement("div", { className: "col version" }, track && React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "version-btn my-auto" },
                                React.createElement(Button, { className: 'popup-click-handler', color: 'blue', selected: true, text: track.track.tag ? track.track.tag.name : 'Unknown', onClick: function (e) {
                                        _this.setVersionPopupPosition(e);
                                    } })),
                            React.createElement("div", { className: "arrows" },
                                React.createElement("div", { onClick: function () {
                                        if (tagPosition > 0) {
                                            var version = track.album.media[tagPosition - 1];
                                            PlaybackManager.getInstance().startTrack({
                                                album: track.album,
                                                playlist: track.playlist,
                                                track: version,
                                                playbackInfo: version.stream_info
                                            });
                                        }
                                        else {
                                            PlaybackManager.getInstance().rewind(true);
                                        }
                                    } },
                                    React.createElement("img", { src: ARROWS_UP_SVG, height: 11, className: 'opacity-control' })),
                                React.createElement("div", { onClick: function () {
                                        if (tagPosition < (track.album.media.length - 1)) {
                                            var version = track.album.media[tagPosition + 1];
                                            PlaybackManager.getInstance().startTrack({
                                                album: track.album,
                                                playlist: track.playlist,
                                                track: version,
                                                playbackInfo: version.stream_info
                                            });
                                        }
                                    } },
                                    React.createElement("img", { src: ARROWS_DOWN_SVG, height: 11, className: 'opacity-control' }))))),
                        React.createElement("div", { className: "col controls" },
                            React.createElement("div", { className: "img previous my-auto opacity-control", onClick: function () { return PlaybackManager.getInstance().rewind(); } },
                                React.createElement("img", { src: ARROWS_LEFT_SVG, width: 19 })),
                            React.createElement("div", { ref: function (ref) { return _this.playPauseButton = ref; }, className: "img play my-auto grow", onClick: function () {
                                    if (PlaybackManager.getInstance().getPlayingState() < PlayerState.Loading) {
                                        PlaybackManager.getInstance().play();
                                    }
                                    else {
                                        PlaybackManager.getInstance().pause();
                                    }
                                } },
                                PlaybackManager.getInstance().getPlayingState() < PlayerState.Loading && React.createElement("img", { src: PLAY_SMALL_WHITE_SVG, className: "play" }),
                                PlaybackManager.getInstance().getPlayingState() >= PlayerState.Loading && React.createElement("img", { src: PAUSE_SMALL_WHITE_SVG, className: "pause" })),
                            React.createElement("div", { className: "img next my-auto opacity-control", onClick: function () { return PlaybackManager.getInstance().forward(); } },
                                React.createElement("img", { src: ARROWS_RIGHT_SVG, width: 19 }))),
                        React.createElement(PlayerProgress, { className: 'col bpmprogress', maxDuration: _this.isPreview ? 30 : 0 }),
                        React.createElement("div", { className: "col settings" },
                            React.createElement("div", { className: "volume my-auto", onMouseEnter: function () {
                                    _this.setState({ volumePopupOpenDelayedClose: true });
                                    _this.volumePoupCoseTimer && clearTimeout(_this.volumePoupCoseTimer);
                                }, onMouseLeave: function () {
                                    _this.volumePoupCoseTimer = setTimeout(function () {
                                        _this.setState({ volumePopupOpenDelayedClose: false });
                                    }, 400);
                                } },
                                React.createElement("div", { className: "volume-control my-auto", style: { visibility: _this.state.volumePopupOpenDelayedClose ? _this.state.popupVisibleState : 'hidden', right: "95px" } },
                                    React.createElement(Slider, { vertical: true, min: 0, max: 1, step: .02, value: _this.state.muted ? 0 : _this.state.volume, onChange: function (e) {
                                            if (_this.videoElem) {
                                                _this.setState({ volume: e, muted: false });
                                                _this.videoElem.volume = e;
                                                _this.videoElem.muted = false;
                                            }
                                        } })),
                                React.createElement("img", { className: "opacity-control", onClick: function (e) {
                                        if (_this.videoElem)
                                            _this.videoElem.muted = !_this.state.muted;
                                        _this.setState({ muted: !_this.state.muted });
                                    }, src: (!_this.state.muted && _this.state.volume > 0) ? (_this.state.volume > 0.5 ? VOLUME_2_SVG : VOLUME_1_SVG) : VOLUME_0_SVG, height: 23 })),
                            React.createElement("div", { className: "settings my-auto popup-click-handler", onClick: function (e) {
                                    _this.setHQPopupPosition(e, !_this.state.hqPopupOpen);
                                } },
                                React.createElement("img", { className: "opacity-control", src: SETTINGS_SVG, height: 23 })),
                            React.createElement("div", { className: "queue my-auto popup-click-handler", onClick: function (e) {
                                    if (!_this.state.queuePopupOpen) {
                                        _this.setState({ queuePopupOpen: true, queuePopupOpenDelayedClose: true, hqPopupOpen: false });
                                    }
                                    else {
                                        _this.closeQueuePopup();
                                    }
                                } },
                                React.createElement("img", { className: "opacity-control", src: QUEUE_SVG, height: 22 })))));
            }
        });
    };
    return Player;
}(React.Component));
export default Player;
var PlayerProgress = /** @class */ (function (_super) {
    __extends(PlayerProgress, _super);
    function PlayerProgress(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.onResize = _this.onResize.bind(_this);
        return _this;
    }
    PlayerProgress.prototype.componentDidMount = function () {
        var _this = this;
        PlaybackManager.getInstance().addPlaybackProgressStateListener(function (state) {
            _this.setState({ progressState: state });
        });
        PlaybackManager.getInstance().addPlaybackStateListener(function (state) {
            if (state.media && state.media.track && state.media.track.waves) {
                if (_this.state.coloredWave != state.media.track.waves.colored || _this.state.grayWave != state.media.track.waves.gray) {
                    _this.setState({ grayWave: state.media.track.waves.gray, coloredWave: state.media.track.waves.colored });
                }
            }
        });
        document.addEventListener('resize', this.onResize);
    };
    PlayerProgress.prototype.componentWillUnmount = function () {
        document.removeEventListener('resize', this.onResize);
    };
    PlayerProgress.prototype.onResize = function (e) {
        if (this.containerRef)
            this.setState({ progressContainerWidth: this.containerRef.clientWidth });
    };
    PlayerProgress.prototype.setContainerRef = function (ref) {
        this.containerRef = ref;
        var cssOffset = 40 * 2 /* left duration and right duration */ + 8 * 2 /* left margin of wave and right duration */ + 15 * 2; /* col padding */
        if (this.containerRef && this.state.progressContainerWidth != (this.containerRef.clientWidth - cssOffset))
            this.setState({ progressContainerWidth: this.containerRef.clientWidth - cssOffset });
    };
    PlayerProgress.formatProgress = function (seconds) {
        if (!seconds) {
            return undefined;
        }
        return moment.utc(moment.duration(seconds, "s").asMilliseconds()).format("mm:ss");
    };
    PlayerProgress.prototype.progressInPercent = function (seconds, duration) {
        if (!seconds || !duration) {
            return 0;
        }
        return (100 / duration) * seconds;
    };
    PlayerProgress.prototype.render = function () {
        var _this = this;
        var coloredStyle = {
            width: (this.state.progressContainerWidth || 0) + 'px',
            backgroundImage: (this.state.coloredWave ? "url('" + this.state.coloredWave + "')" : '')
        };
        return React.createElement("div", { className: this.props.className || '', ref: function (ref) { return _this.setContainerRef(ref); } },
            React.createElement("div", { className: "progress-time my-auto" }, PlayerProgress.formatProgress(PlaybackManager.getInstance().getProgress()) || '00:00'),
            PlaybackManager.getInstance().isPlayingVideo() && React.createElement("div", { className: "wave wave-video" }),
            !PlaybackManager.getInstance().isPlayingVideo() && React.createElement("div", { className: "wave", onClick: function (e) {
                    if (PlaybackManager.getInstance().getDuration()) {
                        var percent = (100 / e.currentTarget.clientWidth) * e.nativeEvent.offsetX;
                        var targetDuration = PlaybackManager.getInstance().getDuration() * (percent / 100);
                        PlaybackManager.getInstance().seek(targetDuration);
                    }
                }, style: { backgroundImage: (this.state.grayWave ? "url('" + this.state.grayWave + "')" : ''), position: 'relative' } },
                React.createElement("div", { className: "colored-wave", style: {
                        width: this.progressInPercent(PlaybackManager.getInstance().getProgress(), PlaybackManager.getInstance().getDuration()) + "%"
                    } },
                    React.createElement("div", { className: "colored-wave-inner", style: coloredStyle })),
                this.props.maxDuration && (this.progressInPercent(this.props.maxDuration, PlaybackManager.getInstance().getDuration()) > 0) && React.createElement("div", { className: "lead-wave-overlay", "data-width": 100 - this.progressInPercent(this.props.maxDuration, PlaybackManager.getInstance().getDuration()), style: { '--overlay-width': 100 - this.progressInPercent(this.props.maxDuration, PlaybackManager.getInstance().getDuration()) + "%" } })),
            React.createElement("div", { className: "duration-time my-auto" }, PlayerProgress.formatProgress(PlaybackManager.getInstance().getDuration()) || '00:00'));
    };
    return PlayerProgress;
}(React.PureComponent));
//# sourceMappingURL=Player.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/player/Player.js
// module id = 268
// module chunks = 0